import { put } from './requests'

const resourcePath = 'accounts/hooks'

export function updateAccountHooks (hooksAttributes) {
  return put(resourcePath, { hooksAttributes })
}
